import { errorHandler } from '@/app/shared/services/error-handler.js';
import store from '@/store/store.js';

export default {

  //#region Periods
  fetchAllProjects({ commit }) {
    return new Promise((resolve, reject) => {

      this._vm.$webApi.get("geo/project")
        .then((response) => {
          commit('SET_PROJECTS', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  fetchPeriodListItems({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("geo/mrmr/statementPeriods/findAll")
        .then((response) => {
          commit('SET_PERIODS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addPeriod({ commit }, statementPeriod) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/mrmr/statementPeriods/create', { statementPeriod })
        .then((response) => {
          commit('ADD_PERIOD', Object.assign(statementPeriod, { id: response.data.model.id }))
          resolve(response)
        })
        .catch((error) => {
          reject(error); 
        })
    })
  },
  updatePeriod({ commit }, statementPeriod) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/mrmr/statementPeriods/edit', { statementPeriod })
        .then((response) => {
          commit('UPDATE_PERIOD', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  removePeriod({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/mrmr/statementPeriods/delete', { id })
        .then((response) => {
          commit('REMOVE_PERIOD', id)
          resolve(response)
        })
        .catch((error) => {
          reject(error) 
        })
    })
  },

  //#endregion

  //#region Statements

  fetchStatementListItems({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("geo/mrmr/statements/find", { params: {
        projectId
      }})
        .then((response) => {
          commit('SET_STATEMENTS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error);
        })
    })
  },
  addStatement({ commit }, statement) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/mrmr/statements/create', { statement })
        .then((response) => {
          commit('ADD_STATEMENT', Object.assign(statement, { id: response.data.model.id }))
          resolve(response)
        })
        .catch((error) => {
          reject(error); 
        })
    })
  },
  updateStatement({ commit }, statement) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/mrmr/statements/edit', { statement })
        .then((response) => {
          commit('UPDATE_STATEMENT', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error); 
        })
    })
  },
  removeStatement({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/mrmr/statements/delete', { id })
        .then((response) => {
          commit('REMOVE_STATEMENT', id)
          resolve(response)
        })
        .catch((error) => {
          reject(error) 
        })
    })
  },
  fetchQPGeologyGroupUsers({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$graphApi.get("/groups/" + store.state.activeDirectoryConfigurations.mrmrQpGeologyGroupId + "/members")
        .then((response) => {
          commit('SET_GEOLOGY_USERS', response.data.value)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.loadingError(this._vm, error);
          reject(error) 
        })
    })
  },
  fetchQPEngineeringGroupUsers({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$graphApi.get("/groups/" + store.state.activeDirectoryConfigurations.mrmrQpEngineergingGroupId + "/members")
        .then((response) => {
          commit('SET_ENGINEERING_USERS', response.data.value)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.loadingError(this._vm, error);
          reject(error) 
        })
    })
  },
  addQP({ commit }, qp) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/mrmr/qps/create', { qp })
        .then((response) => {
          commit('ADD_QP', Object.assign(qp, { id: response.data.model.id }))
          resolve(response)
        })
        .catch((error) => {
          reject(error); 
        })
    })
  },
  fetchQPListItems({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("geo/mrmr/qps/findAll")
        .then((response) => {
          commit('SET_QPS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error);
        })
    })
  },
  updateQP({ commit }, qp) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/mrmr/qps/edit', { qp })
        .then((response) => {
          commit('UPDATE_QP', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error); 
        })
    })
  },
  removeQP({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/mrmr/qps/delete', { id })
        .then((response) => {
          commit('REMOVE_QP', id)
          resolve(response)
        })
        .catch((error) => {
          reject(error) 
        })
    })
  },
  
  updateSelectedPeriodId({ commit }, val) {
    commit('UPDATE_PERIOD_ID', val)
  },
  addProfessionalOrder({ commit }, ProfessionalOrder) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/mrmr/ProfessionalOrders/create', { ProfessionalOrder })
        .then((response) => {
          commit('ADD_PROFESSIONAL_ORDER', Object.assign(ProfessionalOrder, { id: response.data.model.id }))
          resolve(response)
        })
        .catch((error) => {
          reject(error); 
        })
    })
  },
  fetchProfessionalOrders({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("geo/mrmr/ProfessionalOrders/findAll")
        .then((response) => {
          commit('SET_PROFESSIONAL_ORDERS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error);
        })
    })
  },
  updateProfessionalOrder({ commit }, ProfessionalOrder) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/mrmr/ProfessionalOrders/edit', { ProfessionalOrder })
        .then((response) => {
          commit('UPDATE_PROFESSIONAL_ORDER', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error); 
        })
    })
  },
  removeProfessionalOrder({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/mrmr/ProfessionalOrders/delete', { id })
        .then((response) => {
          commit('REMOVE_PROFESSIONAL_ORDER', id)
          resolve(response)
        })
        .catch((error) => {
          reject(error) 
        })
    })
  },
  //#endregion

  //#region Variance

  fetchVariances({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("geo/mrmr/variances/findAll", { params: { projectId }})
        .then((response) => {
          commit('SET_VARIANCES', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error);
        })
    })
  },
  removeVariance({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('geo/mrmr/variances/delete', { id })
        .then((response) => {
          commit('REMOVE_VARIANCE', id)
          resolve(response)
        })
        .catch((error) => {
          reject(error) 
        })
    })
  }

  //#endregion
}
